import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import VisibilitySensor from "react-visibility-sensor";
import { Swiper, SwiperSlide } from "swiper/react";
import { EffectFade, Navigation, Autoplay } from "swiper/modules";

import arrowLeft from "../../../../assets/img/components/arrow-left.webp";
import arrowRight from "../../../../assets/img/components/arrow-right.webp";

import stars from "../../../assets/img/landingPageThree/sectionFive/stars.webp"

import "swiper/css";
import "swiper/css/navigation";
import 'swiper/css/effect-fade';

const DATA = [
  {
    id: 1,
    nameKey: "lp4_testimonial1_name",
    positionKey: "lp4_testimonial1_position",
    textKey: "lp4_testimonial1_text",
  },
  {
    id: 2,
    nameKey: "lp4_testimonial2_name",
    positionKey: "lp4_testimonial2_position",
    textKey: "lp4_testimonial2_text",
  },
  {
    id: 3,
    nameKey: "lp4_testimonial3_name",
    positionKey: "lp4_testimonial3_position",
    textKey: "lp4_testimonial3_text",
  },
  {
    id: 4,
    nameKey: "lp4_testimonial4_name",
    positionKey: "lp4_testimonial4_position",
    textKey: "lp4_testimonial4_text",
  },
];

function SectionFive() {
  const [isVisible, setIsVisible] = useState(false);
  const { t } = useTranslation();

  const onChange = (visibility) => {
    if (visibility) {
      setIsVisible(true);
    }
  };

  return (
    <VisibilitySensor onChange={onChange} partialVisibility minTopValue={400}>
      <div id="feedback" className={`sectionFive ${isVisible ? "visible" : ""}`}>
        <div className="sectionFiveTitle">
          <p className={`${isVisible ? "visible" : ""}`}>
            {t("lp4_feedback_tag")}
          </p>
          <h1 className={`${isVisible ? "visible" : ""}`}>
            {t("lp4_feedback_title")}
          </h1>
        </div>
        <Swiper
          className={`${isVisible ? "visible" : ""}`}
          navigation={{
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          }}
          effect={'fade'}
          modules={[Navigation, EffectFade, Autoplay]}
          speed={800}
          slidesPerView={"1"}
          spaceBetween={0}
          loop={true}
          autoplay={{
            delay: 5000,
            disableOnInteraction: false,
          }}
        >
          <div className={`swiper-button-prev`}>
            <img src={arrowLeft} width={"40px"} alt="" />
          </div>
          {DATA.map((item) => (
            <SwiperSlide key={item.id}>
              <div className={`card ${item.class}`}>
                <img className={` ${isVisible ? "visible" : ""}`} src={stars} alt="" />
                <p className={`text1 ${isVisible ? "visible" : ""}`}>
                  {t(item.nameKey)}
                </p>
                <p className={`text2 ${isVisible ? "visible" : ""}`}>
                  {t(item.positionKey)}
                </p>
                <p className={`text3 ${isVisible ? "visible" : ""}`}>
                  {t(item.textKey)}
                </p>
              </div>
            </SwiperSlide>
          ))}
          <div className={`swiper-button-next`}>
            <img src={arrowRight} width={"40px"} alt="" />
          </div>
        </Swiper>
      </div>
    </VisibilitySensor>
  );
}
export default SectionFive;
